module.exports = __webpack_public_path__ + "img/Features_Screen2.69df2cb5.png";